import GhostLoader from 'react-ghost-loader';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import {
  NA,
  NO_DATA,
  OTS_SGM_MNG_CPM,
  OTS_SGM_MNG_EFF_CPM,
  OTS_SGM_MNG_IMPRESSIONS_THIS_MONTH,
  OTS_SGM_MNG_LAST_ID_REFRESH,
  OTS_SGM_MNG_POM,
  OTS_SGM_MNG_REVENUE_THIS_MONTH,
  OTS_SGM_MNG_TOTAL_IMPRESSIONS,
  OTS_SGM_MNG_TOTAL_REVENUE,
} from '../../../content';
import { SegmentDetail } from '../types';
import { isNil } from 'lodash';
import * as Styled from './index.styles';

interface OtsSegmentDetailStatCardsProps {
  segmentDetail?: SegmentDetail;
  loading: boolean;
}

const OtsSegmentDetailStatCards: React.FC<OtsSegmentDetailStatCardsProps> = ({
  segmentDetail,
  loading,
}) => {
  const STAT_CARDS = [
    {
      title: OTS_SGM_MNG_TOTAL_REVENUE,
      dataKey: 'totalRevenue',
      format: (value: number | string | null | undefined) => {
        if (isNil(value) || typeof value !== 'number') return NA;
        return `$${value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
    },
    {
      title: OTS_SGM_MNG_TOTAL_IMPRESSIONS,
      dataKey: 'totalImpressions',
      format: (value: number | string | null | undefined) => {
        if (isNil(value) || typeof value !== 'number') return NA;
        return value.toLocaleString('en-US');
      },
    },
    {
      title: OTS_SGM_MNG_REVENUE_THIS_MONTH,
      dataKey: 'revenueThisMonth',
      format: (value: number | string | null | undefined) => {
        if (isNil(value) || typeof value !== 'number') return NA;
        return `$${value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
    },
    {
      title: OTS_SGM_MNG_IMPRESSIONS_THIS_MONTH,
      dataKey: 'impressionsThisMonth',
      format: (value: number | string | null | undefined) => {
        if (isNil(value) || typeof value !== 'number') return NA;
        return value.toLocaleString('en-US');
      },
    },
    {
      title: OTS_SGM_MNG_CPM,
      dataKey: 'cpm',
      format: (value: number | string | null | undefined) => {
        if (isNil(value) || typeof value !== 'number') return NA;
        return `$${value.toFixed(2)}`;
      },
    },
    {
      title: OTS_SGM_MNG_EFF_CPM,
      dataKey: 'effectiveCpm',
      format: (value: number | string | null | undefined) => {
        if (isNil(value) || typeof value !== 'number') return NA;
        return `$${value.toFixed(2)}`;
      },
    },
    {
      title: OTS_SGM_MNG_POM,
      dataKey: 'pom',
      format: (value: number | string | null | undefined) => {
        if (isNil(value) || typeof value !== 'number') return NA;
        return `${value}%`;
      },
    },
    {
      title: OTS_SGM_MNG_LAST_ID_REFRESH,
      dataKey: 'lastUpdatedAt',
      format: (value?: string | number | null) => {
        // Use isNil to check for null/undefined
        if (isNil(value) || typeof value !== 'string') return NO_DATA;
        const date = new Date(value);
        return date.toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        });
      },
    },
  ];

  return (
    <Grid container spacing={2}>
      {STAT_CARDS.map((card, index) => {
        const value = loading
          ? undefined
          : (segmentDetail?.[card.dataKey as keyof SegmentDetail] as
              | number
              | string
              | undefined);
        const formattedValue = loading ? null : card.format(value);

        return (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Styled.StatCard>
              <Styled.StatLabel>{card.title}</Styled.StatLabel>
              <Styled.StatValue>
                {loading ? (
                  <GhostLoader height="32px" width="120px" />
                ) : (
                  formattedValue || NO_DATA
                )}
              </Styled.StatValue>
            </Styled.StatCard>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default OtsSegmentDetailStatCards;
